<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.application_link_key')
      }}</span>
    </div>
    <div class="page-card-content application-link-key-page">
      <div class="mt-20 page-content" v-loading="loading">
        <div v-if="linkKey">
          <div class="mb-10">
            <span>{{ $t('text.application_link_key_desc') }}</span
            >&nbsp;
            <span v-if="p('Organisations.Interoperability.Add')">
              {{ $t('text.remove_application_link_key_desc') }}&nbsp;
              <span class="text-a pointer" @click="generateKey()">{{
                $t('text.generate_a_new_one')
              }}</span
              >.
            </span>
          </div>
          <div class="key-box">
            <svg
              fill="green"
              height="32"
              aria-hidden="true"
              viewBox="0 0 24 24"
              version="1.1"
              width="32"
              data-view-component="true"
              class="octicon octicon-key"
            >
              <path
                d="M16.75 8.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
              ></path>
              <path
                d="M15.75 0a8.25 8.25 0 1 1-2.541 16.101l-1.636 1.636a1.744 1.744 0 0 1-1.237.513H9.25a.25.25 0 0 0-.25.25v1.448a.876.876 0 0 1-.256.619l-.214.213a.75.75 0 0 1-.545.22H5.25a.25.25 0 0 0-.25.25v1A1.75 1.75 0 0 1 3.25 24h-1.5A1.75 1.75 0 0 1 0 22.25v-2.836c0-.464.185-.908.513-1.236l7.386-7.388A8.249 8.249 0 0 1 15.75 0ZM9 8.25a6.733 6.733 0 0 0 .463 2.462.75.75 0 0 1-.168.804l-7.722 7.721a.25.25 0 0 0-.073.177v2.836c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-1c0-.966.784-1.75 1.75-1.75H7.5v-1c0-.966.784-1.75 1.75-1.75h1.086a.25.25 0 0 0 .177-.073l1.971-1.972a.75.75 0 0 1 .804-.168A6.75 6.75 0 1 0 9 8.25Z"
              ></path>
            </svg>
            <div>
              <div class="bold-font">{{ $t('text.application_link_key') }}</div>
              <div>
                <span>{{ linkKey }}</span>
                <i
                  class="el-icon-document-copy pointer copy-icon"
                  @click="copyToClipboard()"
                ></i>
              </div>
            </div>
            <el-button
              type="danger"
              size="mini"
              plain
              @click="removeKey()"
              v-if="p('Organisations.Interoperability.Add')"
              >{{ $t('text.delete') }}</el-button
            >
          </div>
        </div>
        <el-empty
          description="Your organization doesn't have a Link Key"
          v-else
        >
          <el-button
            class="common-btn min-w-80"
            :loading="generateLoading"
            @click="handleGenerateKey()"
            v-if="p('Organisations.Interoperability.Add')"
            >{{ $t('text.generate') }}</el-button
          >
        </el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      linkKey: '',
      loading: false,
      user: JSON.parse(localStorage.getItem('user')),
      generateLoading: false
    }
  },
  mounted() {
    this.getLinkKey()
  },
  methods: {
    getLinkKey() {
      this.loading = true
      ApiService.GetLinkKey(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          let data = response.data.data
          if (data) {
            this.linkKey = data.Code
          } else {
            this.linkKey = null
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    generateKey() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.generate_new_application_link_key_warning'
        )}.</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.warning'),
        {
          confirmButtonText: this.$t('text.continue').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleGenerateKey()
        })
        .catch(() => {})
    },
    handleGenerateKey() {
      this.generateLoading = true
      ApiService.GenerateLinkKey(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.generateLoading = false
          if (response.data.success) {
            this.getLinkKey()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.generateLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    copyToClipboard() {
      this.$copyText(this.linkKey).then(
        () => {
          this.$message({
            message: this.$t('text.copied_to_clipboard'),
            type: 'success'
          })
        },
        () => {
          this.$message({
            message: this.$t('text.failed_to_copy'),
            type: 'error'
          })
        }
      )
    },
    removeKey() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.generate_new_application_link_key_warning'
        )}.</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.warning'),
        {
          confirmButtonText: this.$t('text.continue').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleRemoveKey()
        })
        .catch(() => {})
    },
    handleRemoveKey() {
      this.loading = true
      ApiService.RemoveLinkKey(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getLinkKey()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.is-enabled::v-deep {
  &.el-switch.is-disabled {
    opacity: 1;
  }
}
</style>
